// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class ConfirmView extends JQueryView {
  constructor() {
    super('.confirm');
    this.render();
  }

  @on({
    event: 'change',
    selector: '#officer_approval_stockholder_meeting_comment',
  })
  onChangeComment() {
    const comment = $('#officer_approval_stockholder_meeting_comment').val();
    $('input:hidden[name="test_comment"]').val(comment);
  }

  @on({
    event: 'click',
    selector: '#use_sample',
  })
  onClickUseSample() {
    const body = $('#sample_sentence_body')
      .find('p')
      .text();
    const textarea = $('#officer_approval_stockholder_meeting_comment');
    textarea.val(body);
    $('input:hidden[name="test_comment"]').val(body);
  }

  render() {
    const comment = $('#officer_approval_stockholder_meeting_comment').val();
    $('input:hidden[name="test_comment"]').val(comment);
  }
}
